export default "__VITE_ASSET__D1Gh5jjT__"